<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3">
      <search-form :fields="search" />
    </el-button-group>

    <!-- 商品编码, 商品名称, 商品类型, 销售类型, 库存, 所属仓库, 最后修改时间, 最后修改人, 操作（查询变动记录） -->
    <el-table :data="warehouseGoods" resource="warehouse-goods">
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="warehouse.name" label="所属仓库" />
      <el-table-column prop="nums" label="当前库存" />
      <el-table-column prop="good.sku_id" label="商品编码" />
      <el-table-column prop="good.name" label="商品名称" />
      <el-table-column label="商品类型">
        <template slot-scope="scope">
          {{ goodsTypes[scope.row.good.goods_type] }}
        </template>
      </el-table-column>
      <el-table-column label="销售类型">
        <template slot-scope="scope">
          {{ salesTypes[scope.row.good.sales_type] }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="created_at" label="添加时间" width="170" /> -->
      <el-table-column prop="updated_at" label="修改时间" width="170" />
      <el-table-column label="操作" width="150">
        <template #default="{ row, $index }">
          <el-button-group>
            <el-button size="small" @click="onShowStoreLogs($index, row)">变动记录</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="setStoreLogsDialog" width="1200px" append-to-body>
      <el-date-picker
        v-model="dialogQueryData.stats_date"
        type="daterange"
        range-separator="至"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        clearable
        :picker-options="pickerOptions"
      />
      &nbsp;
      <el-button type="primary" @click="queryList">查询</el-button>
      <el-divider />
      <el-table :data="storeLogsList" v-loading="dialogLoading">
        <el-table-column type="index" property="id" label="序号" width="100" />
        <el-table-column prop="before_num" label="变动前数量" width="130" />
        <el-table-column prop="num" label="变动数量" width="130" />
        <el-table-column prop="after_num" label="变动后数量" width="130" />
        <el-table-column prop="log_text" label="变动说明" />
        <el-table-column prop="op_name" label="操作员账号" width="160" />
        <el-table-column prop="created_at" label="变动时间" width="170" />
      </el-table>
      <div>
        <el-divider />
        <el-pagination
          background
          @current-change="dialogQueryPageChange"
          :current-page.sync="dialogQueryData.current_page"
          :page-size="dialogQueryData.per_page"
          layout="total, prev, pager, next,jumper"
          :total="dialogQueryData.total"
        />
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { getWarehouseGoodLogs } from '@/api/warehouse-good-logs'
import { getWarehouseGoods } from '@/api/warehouse-goods'
import Pagination from '@c/Pagination'
import SearchForm from '@c/SearchForm'
export default {
  name: 'Index',
  components: {
    SearchForm,
    Pagination,
  },
  data() {
    return {
      search: [
        {
          field: 'sku_id',
          label: '商品编码',
        },
        {
          field: 'good_name',
          label: '商品名称',
        },
        {
          field: 'warehouse_name',
          label: '所属仓库',
        },
      ],
      goodsTypes: {
        0: '普通商品',
        1: '报单商品',
        2: '积分商品',
      },
      salesTypes: {
        1: '线上平台',
        2: '线下平台',
        3: '所有平台',
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '本月',
            onClick(picker) {
              const date = new Date()
              date.setDate(1)
              const start = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate())
              picker.$emit('pick', [start, new Date()])
            },
          },
          {
            text: '今年至今',
            onClick(picker) {
              const end = new Date()
              const start = new Date(new Date().getFullYear(), 0)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setMonth(start.getMonth() - 6)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      warehouseGoods: [],
      page: null,

      defaultDate: [],
      setStoreLogsDialog: false,
      dialogLoading: true,
      dialogTitle: '',
      dialogRow: null,
      storeLogsList: [],
      storeLogsPage: {},
      dialogQueryData: {
        stats_date: [],
        current_page: 1,
        page_size: 8,
      },
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        const {
          data: { data, meta },
        } = await getWarehouseGoods(newVal.query)
        this.warehouseGoods = data
        this.page = meta
        const date = new Date()
        date.setDate(1)
        const start = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
        const end = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
        this.dialogQueryData.stats_date = [start, end]
        this.loading = false
      },
      immediate: true,
    },
  },
  methods: {
    async onShowStoreLogs(index, row) {
      this.dialogTitle = row.good.name + ', 仓库【' + row.warehouse.name + '】变动记录'
      this.dialogRow = row
      this.setStoreLogsDialog = true
      this.dialogQueryData.goods_id = row.goods_id
      this.dialogQueryData.warehouse_code = row.warehouse_code
      this.getDialogQueryData()
    },
    async dialogQueryPageChange(val) {
      this.dialogQueryData.page = val
      this.getDialogQueryData()
    },
    async queryList() {
      this.getDialogQueryData()
    },
    async getDialogQueryData() {
      this.dialogLoading = true
      const {
        data: { data, meta },
      } = await getWarehouseGoodLogs(this.dialogQueryData)
      this.storeLogsList = data
      this.storeLogsPage = meta
      this.dialogLoading = false
    },
  },
}
</script>
